module.exports = __webpack_public_path__ + "img/Logo-29.a1a3471e.svg";